import { ArtifactUser } from '../../forgeApi.types'

export interface ShareArtifactRequest {
  publicId: string
  users: ArtifactUser[]
}
